/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class UndoRedoAPI
 * @hideconstructor
 * @classdesc  API class that handles undo and redo functionality
 */
define([], () => {
	return class UndoRedoAPI {

		/**
		 * @function UndoRedoAPI#canUndo
		 * @description Determines whether undo can be applied.
		 * @returns True if undo can be applied, otherwise false
		 */
		canUndo() { }

		/**
		 * @function UndoRedoAPI#canRedo
		 * @description Determines whether redo can be applied.
		 * @returns True if redo can be applied, otherwise false
		 */
		canRedo() { }

		/**
		 * @function UndoRedoAPI#undo
		 * @description Undo the last operation.
		 */
		undo() { }

		/**
		 * @function UndoRedoAPI#redo
		 * @description Redo will restore the last action that was undone.
		 */
		redo() { }

		/**
		 * @function UndoRedoAPI#clearStack
		 * @description Clears the full undo/redo stack.
		 */
		clearStack() { }
	};
});
